import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Seo } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { ProjectCard } from "../components/site/ProjectCard";
import { CTASection } from "../components/site/CTASection";
import { PROJECTS, STATUS_FILTERS } from "../data/projects";

export default function Projects() {
  const [filter, setFilter] = useState("All");
  const filtered =
    filter === "All" ? PROJECTS : PROJECTS.filter((p) => p.status === filter);

  return (
    <>
      <Seo
        title="Projects | Arc & Hollow — London Residential Interiors"
        description="A considered index of Arc & Hollow's residential interior architecture projects and concept work across London."
        path="/projects"
      />
      <PageHero
        overline="Projects"
        titleLines={["Work, and the", "thinking within it."]}
        intro="Selected residential studies exploring the relationship between architecture, materiality, art and everyday life. Conceptual and in-development work is identified clearly."
      />

      <section className="container-x pb-24 md:pb-32">
        <div className="flex flex-wrap gap-x-2 gap-y-3 mb-12 border-b border-charcoal/15 pb-6" role="tablist" aria-label="Filter projects by status">
          {STATUS_FILTERS.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              data-testid={`filter-${cat.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              aria-pressed={filter === cat}
              className={`px-5 py-2.5 text-xs uppercase tracking-overline font-semibold transition-colors duration-400 ${
                filter === cat
                  ? "bg-charcoal text-chalk"
                  : "text-olive hover:text-charcoal border border-charcoal/15"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <motion.div layout className="grid gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
          <AnimatePresence mode="popLayout">
            {filtered.map((p, i) => (
              <motion.div
                key={p.slug}
                layout
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                className={i % 3 === 1 ? "md:mt-16" : ""}
              >
                <ProjectCard project={p} index={i} />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        {filtered.length === 0 && (
          <p className="text-center text-olive font-light py-20">No projects with this status yet.</p>
        )}
      </section>

      <CTASection />
    </>
  );
}
